import { render, staticRenderFns } from "./StepsOptionsHead.vue?vue&type=template&id=622f04d6"
import script from "./StepsOptionsHead.vue?vue&type=script&lang=js"
export * from "./StepsOptionsHead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports